<div class="question-container" *ngIf="!hidden && question">
  <mat-expansion-panel
    [disabled]="!enabled"
    [class.completed]="question.Completed || expanded"
    [class.incompleted]="!question.Completed && !expanded"
    [expanded]="expanded"
    class="question-panel"
    [hideToggle]="true"
    (opened)="openPanel()"
    (closed)="expanded = false"
  >
    <mat-expansion-panel-header
      collapsedHeight="auto"
      expandedHeight="auto"
      class="question-head"
    >
      <mat-panel-title class="question-head-title" *ngIf="question">
        <p
          class="question-head-title expanded"
          *ngIf="expanded && showNumber && question"
        >
          {{ index + 1 }}/{{ total }}
        </p>
        <p
          class="question-head-title collapsed"
          *ngIf="!expanded"
          [innerHTML]="question.QuestionText"
          [attr.data-Id]="getQuestionId()"
        ></p>

        <p
          class="question-head-subtitle expanded"
          *ngIf="expanded"
          [innerHTML]="question.QuestionText"
          [attr.data-Id]="getQuestionId()"
        ></p>
        <h4
          class="question-head-subtitle collapsed"
          *ngIf="
            !expanded &&
            question &&
            question.Answer &&
            question.Answer.AnswerText
          "
        >
          {{ question.Answer.AnswerText }}
        </h4>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div
      *ngIf="question && (formStyle == 'RadioButton' || formStyle == 'RadioButtonInputField')" 
      class="questionChoices">
      <mat-radio-group
        (change)="selectionChanged($event)"
        class="demands-radio-group"
        [formControl]="questionsFormControl"
      >
        <mat-radio-button
          *ngFor="let choice of question.Choices"
          [value]="choice.AnswerText"
        >
          {{ choice.AnswerText }}
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <form [formGroup]="containerFormControl">
      <!-- ========================  Control One =================================== -->
      <div
        *ngIf="
          question &&
          (formStyle == 'InputField' || formStyle == 'RadioButtonInputField') &&
          resourceDataOne &&
          (listItemsOne == undefined || listItemsOne == null)
        "
        class="questionChoices "
      >
        <adp-input
          [resourceData]="resourceDataOne"
          formControlName="inputControlOne"
          [class]="classControlOne"
          (ngModelChange)="ngFormModelChangeEvent($event)"
        ></adp-input>
      </div>

      <div
        *ngIf="
          question &&
          (formStyle == 'InputField' || formStyle == 'RadioButtonInputField') &&
          resourceDataOne &&
          listItemsOne
        "
        class="questionChoices "
      >
        <adp-select
          [resourceData]="resourceDataOne"
          formControlName="inputControlOne"
          [listItems]="listItemsOne"
          [class]="classControlOne"
          (selectionChange)="ngFormModelChangeEvent($event)"
        >
        </adp-select>
      </div>
      <!-- ======================== Endof Control One =================================== -->

      <!-- ========================  Control Two =================================== -->

      <div
        *ngIf="
          question &&
          (formStyle == 'InputField' || formStyle == 'RadioButtonInputField') &&
          resourceDataTwo &&
          (listItemsTwo == undefined || listItemsTwo == null)
        "
        class="questionChoices "
      >
        <adp-input
          [resourceData]="resourceDataTwo"
          formControlName="inputControlTwo"
          [class]="classControlTwo"
          (ngModelChange)="ngFormModelChangeEvent($event)"
        ></adp-input>
      </div>

      <div
        *ngIf="
          question &&
          (formStyle == 'InputField' || formStyle == 'RadioButtonInputField') &&
          resourceDataTwo &&
          listItemsTwo
        "
        class="questionChoices "
      >
        <adp-select
          [resourceData]="resourceDataTwo"
          formControlName="inputControlTwo"
          [listItems]="listItemsTwo"
          class="classControlTwo"
          (selectionChange)="ngFormModelChangeEvent($event)"
        >
        </adp-select>
      </div>

      <!-- ======================== Endof Control Two =================================== -->
    </form>
  </mat-expansion-panel>
</div>
